export default {"src":"/_next/static/media/ThyroidDisorders.d5a08b2e.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};